<template>
    <modal-wrapper modalClass="modal" :modalName="name" @before-open="beforeOpen">
        <div class="modal__header">
            <h1>{{$t('modals.application_attachments.title')}}</h1>
        </div>
        <div class="modal__content no-side-margins">
            <div v-if="uploadErrors.length" class="alert--error" >
                <span v-for="err in uploadErrors" :key="err"> {{ err }} </span>
            </div>
            <application-attachments-table :application="application" />
            <form enctype="multipart/form-data" novalidate>
                <dropzone-with-loading-button :uploading="attachmentUploading" @fileSelectedEvent="onDocumentSelected($event)" :buttonText="$t('common.upload_file')" />
            </form>
        </div>
        <div class="modal__footer">
            <div class="actions">
                <button class="actions__action--save pull-right" @click="$modal.hide(name)">{{$t('common.done')}}</button>
            </div>
        </div>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import ModalWrapper from '@/components/general/ModalWrapper';
    import ApplicationAttachmentsTable from '@/components/tables/dashboard/ApplicationAttachmentsTable';
    import DropzoneWithLoadingButton from '@/components/general/DropzoneWithLoadingButton';

    import { GET_APPLICATIONS } from '@/store/modules/applications';

    @Component({
        components: {
            ApplicationAttachmentsTable,
            DropzoneWithLoadingButton,
        }
    })
    export default class ApplicationAttachmentsModal extends Vue {
        name = 'application-attachments-modal';
        uploadErrors = [];
        attachmentUploading = false;
        application = {};

        beforeOpen(event) {
            this.uploadErrors = [];
            this.attachmentUploading = false;
            this.application = event.params.application;
        }

        get trajectory() {
            return this.$store.state.trajectory.trajectory;
        }

        onDocumentSelected(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;
            this.uploadDocument(files[0]);
        }

        uploadDocument(file) {
            this.uploadErrors = [];
            var formData = new FormData();
            formData.append('file', file, file.name);


            this.attachmentUploading = true;
            this.axios.post(`trajectories/${this.$store.state.trajectory.trajectory.id}/applications/${this.application.id}/files`, formData)
                .then(res => {
                    this.application.files = [...this.application.files, res.data];
                    this.$notify.success(this.$t('notify.upload_success'));
                })
                .catch(
                    err => {
                        if (err.status === 422 && err.errors) {
                            this.uploadErrors = err.errors;
                            this.$notify.error(this.$t('common.validation_error'));
                        } else {
                            this.$notify.error(this.$t('notify.upload_error'));
                        }
                    }
                ).then(() => {
                    this.attachmentUploading = false;
                    this.$store.dispatch(GET_APPLICATIONS, {});
                });
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/modals/dashboard/ApplicationAttachmentsModal.vue